import styled from 'styled-components/macro';
import { ReactNode } from 'react';
import Footer from '../../layout/Footer';
import GlobalWrap from '../../layout/GlobalWrap';
import Header from '../../layout/Header';

interface SchoolLayoutTypes {
  children: ReactNode;
  menu?: ReactNode;
  headerLoginLinkTo?: string;
}

export default function SchoolLayout({ children, menu, headerLoginLinkTo }: SchoolLayoutTypes) {
  return (
    <Container>
      <GlobalWrap>
        <Header loginLinkTo={headerLoginLinkTo}>
          {menu}
        </Header>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </GlobalWrap>
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  width: 100%;
`;
